export default "__VITE_ASSET__BErLxjLC__"